import { getHttpService } from "../services/http.service";
import { TagManagerEndpoint } from "../endpoints/TagManagerEndpoint";
import { TagManagerOptions } from "../types";

const httpService = getHttpService();

export const getTagManagerArgs = (
  restaurantId: string,
  step: string,
  options?: TagManagerOptions
): any => {
  const endpoint = new TagManagerEndpoint();
  const queryParams = [];
  if (restaurantId && step) {
    queryParams.push({
      queryParamName: "restaurant_id",
      queryParamValue: restaurantId,
    });
    queryParams.push({
      queryParamName: "step",
      queryParamValue: step,
    });
  }
  if (options) {
    for (const [key, value] of Object.entries(options)) {
      queryParams.push({
        queryParamName: key,
        queryParamValue: value,
      });
    }
  }
  endpoint.setQueryParams(queryParams);
  return httpService.get(endpoint);
};
